import styled from 'styled-components';

const ModalInnerContent = styled.div`
    height: 480px;
`;

export {
    ModalInnerContent
};
